import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PROCESS } from "@/site/content";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-20 md:py-28 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
              How it works
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
              See your website first. Pay only if you love it.
            </h2>
          </div>
          <p className="lg:col-span-5 text-gray-600 text-base leading-relaxed">
            Three honest steps. No contracts. No risk. The whole reason we
            built this offer was because small business owners deserve to see
            what they're buying.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 relative">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative rounded-xl bg-white border border-gray-200 p-7 hover:shadow-lg transition-all"
              data-testid={`process-step-${i}`}
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="font-display font-extrabold text-3xl text-blue-700 leading-none">
                  {p.step}
                </div>
                <div className="h-px flex-1 bg-gray-200" />
              </div>
              <h3 className="font-display font-bold text-xl md:text-2xl text-gray-900">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                {p.desc}
              </p>
              {i < PROCESS.length - 1 && (
                <ArrowRight className="hidden md:block absolute -right-5 top-10 text-gray-300" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
